module.exports = __webpack_public_path__ + "img/symbol_questiongreen.95128572.png";